import { render, staticRenderFns } from "./upTips.vue?vue&type=template&id=58671569&scoped=true&"
import script from "./upTips.vue?vue&type=script&lang=js&"
export * from "./upTips.vue?vue&type=script&lang=js&"
import style0 from "./upTips.vue?vue&type=style&index=0&id=58671569&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58671569",
  null
  
)

export default component.exports